<template>
  <section>
    <ClassItem
      v-for="(item, index) in allClasses"
      :editMode="editMode"
      :classItem="item"
      :itemType="'link'"
      :key="index"
    />
  </section>
</template>

<script>
import ClassItem from "../components/ClassItem.vue";

export default {
  name: "ClassItems",
  props: ["editMode", "allClasses"],
  components: {
    ClassItem,
  }
};
</script>

<style lang="scss">
.add-class a {
  color: #fff;
  text-decoration: none;
}
.my-class-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  div {
    display: flex;
    a {
      text-decoration: none;
    }
  }
  button.add-class {
    margin: 1rem 0rem 1rem 1em;
  }
  @media only screen and (max-device-width: 414px) {
    flex-direction: column;
    align-items: start;
    button.add-class {
      margin: 0px 0.5rem 1.5rem 0px;
    }
  }
}

.my-class-header p {
  font-size: 24px;
  text-align: center;
}

.style1 {
  border-color: #008ddb;
}
.style2 {
  border-color: #ead936;
}
.style3 {
  border-color: #e8243d;
}
.style4 {
  border-color: #8d2212;
}
.style5 {
  border-color: #122f8d;
}
</style>